/**
 * Simple promise-chain mutex for serializing async operations.
 * Only one `runExclusive` callback runs at a time; others queue in FIFO order.
 */
export class Mutex {
  private tail: Promise<unknown> = Promise.resolve();

  runExclusive<T>(fn: () => Promise<T>): Promise<T> {
    const result = this.tail.then(fn);
    this.tail = result.catch(() => {});
    return result;
  }
}
